import { api } from '@/shared/axios-client';

export type SaveTestRunSpecRequest = {
  /**
 * The "to" code-build id from Diff Check (e.g. ``320983``). The backend
 * resolves the full scans._id (repoId, branchId, scanRef, etc.) from this.
 * Preferred over the legacy ``scanId``.
 */
  buildId?: number | string;
  /**
   * The "from" (older) code-build id from Diff Check. Persisted alongside the
   * to-build so the saved spec captures the full diff context. Optional.
   */
  fromBuildId?: number | string;
  /** Legacy composite scan id (e.g. "<repo>:<branch>:<pipeline>:<n>"). Optional now that ``buildId`` is supported. */
  scanId?: string;
  name: string;
  entityKeys: string[];
  methodNames: string[];
  includeSelectedMethodTests?: boolean;
  includeLatestBuildTests?: boolean;
  includeFailedBuildTests?: boolean;
  fanDepth?: number;
  createdBy?: string;
};

export type SaveTestRunSpecResponse = {
  success: boolean;
  message?: string;
  data?: {
    specId?: string;
    name?: string;
  };
};

export const saveTestRunSpec = (
  payload: SaveTestRunSpecRequest,
): Promise<SaveTestRunSpecResponse> =>
  api.post('/api/test-intelligence/test-run-spec', payload);
